/**
 * MobileTabBar — Pill-style tab selector for mobile layouts.
 * Matches the existing Standings tab bar visual style.
 */

import type { ReactNode } from "react";

export interface MobileTab {
  id: string;
  label: string;
  icon?: ReactNode;
}

interface MobileTabBarProps {
  tabs: MobileTab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

export function MobileTabBar({
  tabs,
  activeTab,
  onTabChange,
  className = "",
}: MobileTabBarProps) {
  return (
    <div className={`flex rounded-lg tab-group p-0.5 ${className}`}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-medium rounded-md transition-all min-h-[44px] ${
              isActive ? "chip-on" : "text-foreground/70 hover:text-foreground"
            }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
